import Vue from "vue";

export default {
  setActivity(state, activity) {
    state.activity = activity;
  },
  resetActivitySummary(state) {
    // Caution: don't reset activity state
    state.layoutId = null;
    state.isPristine = true;
    state.formValues = {};
    state.formErrors = {};
    state.fieldValues = {};
    state.fieldErrors = {};
    state.selectedProspect = {};
    state.selectedOpportunity = {};
    state.selectedStage = {};
  },
  upsertFormData(state, data) {
    if (data.hasOwnProperty("value"))
      Vue.set(state.formValues, data.id, data.value);
    Vue.set(state.formErrors, data.id, data.error || null);
    state.isPristine = false;
  },
  upsertFieldData(state, data) {
    if (data.hasOwnProperty("value"))
      Vue.set(state.fieldValues, data.id, data.value);
    Vue.set(state.fieldErrors, data.id, data.error || null);
    state.isPristine = false;
  },
  setLayoutId(state, id) {
    state.layoutId = id;
  },
  setSelectedProspect(state, prospect) {
    state.selectedProspect = prospect;
  },
  setSelectedOpportunity(state, opportunity) {
    state.selectedOpportunity = opportunity;
  },
  setSelectedStage(state, stage) {
    state.selectedStage = stage;
  },
  setSelectedTask(state, task) {
    state.selectedTask = task;
  },
  setTitle(state, title) {
    state.activity.title = title;
  },
  setInternalFlag(state, value) {
    state.activity.isInternal = value;
  },
  setPristineFlag(state, value) {
    state.isPristine = value;
  },
  favoriteActivity(state) {
    Vue.set(state.activity, "favorited", true);
  },
  unfavoriteActivity(state) {
    Vue.set(state.activity, "favorited", false);
  },
};



// WEBPACK FOOTER //
// ./~/vue-components/activity-summary/store/mutations.js